import React from "react";
import { ErrorMessage, PublicElevatedSection } from "sprint-common-web";

import { PublicDefaultLayout } from "../../common/ui/layout/PublicDefaultLayout";

export const AuthUserErrorPage: React.VFC = () => {
    return (
        <PublicDefaultLayout>
            <PublicElevatedSection width="20%" height={400} headerText="Authentication Failed">
                <ErrorMessage text="Invalid user configuration. Please contact support." />
            </PublicElevatedSection>
        </PublicDefaultLayout>
    );
};
